<template>
	<a v-if="button"
	       class="Btn top-action-button"
	       :class="topActionButtonClass ?? ''"
	       :href="iframeSrc"
	       :data-module-url="moduleUrl"
	       :data-redirect="getRedirectNode()"
	       :data-redirect-delay="redirectDelay"
	       @click="topActionButtonClickHandler"
	    >
	        <!-- :data-redirect="button.params.result_event ? ( 'close-module' == button.params.result_event ? 'close-module' : urldecode(button.params.redirect_uri ) ) : null" -->
	        <span v-if="'plus' == button.icon" class="mr-2 top-action-button-icon">+</span>
	        {{ button.button_text }}
	    </a>
</template>

<script>


export default {
	name: 'TopActionButton',
	
	props: {
		button: {
			type: Object,
			default: {},
			required: true
		},
		topActionButtonClass: {
			type: String,
			default: '',
			required: false
		},
		isFromSecondayComponent: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			iframeSrc: this.button.iframe_src ?? '',
			moduleUrl: this.button.module ? this.button.module.link : '', 
			redirectDelay: this.button.redirect_delay ?? 0
		}
	},

	inject: {
		tabId: {
            from: 'tabId',
            default: null
        },
        linksTarget: {
        	from: 'dataLinksTarget',
        	default: null
        }
	},

	computed: {
		
	},
	methods: {
		getRedirectNode() {
			// console.log('getRedirectNode::', action_btn)
            if ( ! this.button.result_event ) return null
            if ( 'close-module' == this.button.result_event_type ) {
                return 'close-module'
            }
            if ( 'redirect' == this.button.result_event_type) {
                return decodeURI(this.button.params.redirect_uri)    
            }
            return null
		},
		topActionButtonClickHandler(e) {
			if ( ! this.isFromSecondayComponent ) {
				return;
			}
			e.preventDefault();
			// emit event to the parent component

			this.emitter.emit('topActionButtonClick', {
														'button': this.button,
														'tabId': this.tabId,
														'linksTarget': this.linksTarget,
														'href': this.iframeSrc,
														'event': e,
														'redirect': this.getRedirectNode()
													})
			return false;
			
        }
	}
}
</script>